import { ChangeDetectorRef, Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { LoaderService } from '../../../../shared/sharedServices/loader.service';

@Component({
  selector: 'kt-foreign-attestation-detail',
  templateUrl: './foreign-attestation-detail.component.html',
  styleUrls: ['./foreign-attestation-detail.component.css']
})
export class ForeignAttestationDetailComponent implements OnInit {
  public  title: string;
  public type:string;
  public selectedRadio:any;
  public degree:any;

  public isAlertVisible: Boolean = false;
  public alertType: string;
  public alertMsgValue: string;
  public loader: boolean;

  constructor(private dialogRef: MatDialogRef<ForeignAttestationDetailComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  private loaderService:LoaderService, private sharedServices:SharedService,private cdr:ChangeDetectorRef) { }


  ngOnInit() {
    this.title = this.data.title;
    this.type = this.data.type;
    this.degree = this.data.details
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

  public accept() {
    console.log(this.selectedRadio)
    this.dialogRef.close(true);
  }

  public getDate(date): any {
    let convertedDate = new Date(date).toISOString();
    return new Date(convertedDate).toDateString();
  }

  download(formName) {
		this.isAlertVisible = false;
		this.loader = true;
		this.loaderService.setValue(this.loader);
    let base64 = '';
    let payload;
      payload = {
        STAMP_NO:this.degree.stampNumberTo,
        ATTESTATION_TYPE_NAME:this.degree.attestationTypeName
        // reportName:"NewDasForeignEmbassyStamp"
      
    }
		this.sharedServices.downloadPdf(payload, formName).subscribe(
			(res) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          base64 = res.data;
          this.loader = false;
          this.loaderService.setValue(this.loader);
          this.cdr.detectChanges()
					this.sharedServices.showPdf(formName, base64);
				}
				else {
          // this.isAlertVisible = true;
          this.loader = false;
		      this.loaderService.setValue(this.loader);
					// this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
          // this.alertMsgValue = HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR;
          this.sharedServices
          .openPopupDialog(
            'ERROR',
            HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,
            HEC_CONSTANTS.ERROR_TYPES.error
          )
          .then((res) => {
          });
          this.cdr.detectChanges()
          return
          
				}
			},
			(err) => {
        this.loader = false;
		    this.loaderService.setValue(this.loader);
				// this.isAlertVisible = true;
				// this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
        // this.alertMsgValue = HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR;
        this.sharedServices
          .openPopupDialog(
            'ERROR',
            HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR,
            HEC_CONSTANTS.ERROR_TYPES.error
          )
          .then((res) => {
          });
        this.cdr.detectChanges()
        return;
			}
		)
		// this.loader = false;
		this.loaderService.setValue(false);
  }

}
